import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { fetchOrganizer } from 'modules/organizer/store/organizer/actions';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Ручная перезагрузка организации — кнопка «Повторить» после сбоя.
 *
 * Отдельно от `useFetchOrganizer`, потому что тот вешает эффект автозагрузки: экрану,
 * которому нужна только кнопка, второй эффект дал бы второй запрос при монтировании
 * (автозагрузку уже делает `OrganizerContainer` в макете).
 */
export const useRefetchOrganizer = () => {
  const dispatch = useDispatch();
  const tournamentId = useSelector(authStoreUserTournamentId);

  return useCallback(() => {
    if (!tournamentId) return;
    dispatch(fetchOrganizer({ tournamentId }));
  }, [dispatch, tournamentId]);
};
